import InfoIcon from './info-icon';
export default InfoIcon;
